<template>
    <pg-page title="Private Gym Testimonial - Yorick"
             header="Testimonial van Yorick - Deventer"
             id="testimonial-001"
    >

        <p>
            <strong>Hey Yorick, bent nu een paar weken lid van Private Gym, hebt er al een aantal trainingen op zitten, maar was er iets wat waarover je twijfelde voor je je inschreef?</strong>
        </p>

        <p>
            <em>
                Nee niet tijdens de rondleiding. Ik was al een paar keer langs gelopen, en toen dacht ik dat het heel erg gefocust zou zijn op personal training. Maarre, juist door de rondleiding - had dat de twijfel weg genomen en er juist voor gezorgd dat ik er wel voor ging. Dus eh.. eigenlijk het tegenovergestelde.
            </em>
        </p>

        <p>
            <strong>
                Grappig dat je dat zegt ik had gisteren ook iemand en die dacht dat hij de hele gym voor zichzelf had. Private Gym. Dat het zo private zou zijn. Zo grappig hoe iedereen dat vooraf denkt. Maar daarom doe ik nu ook deze interviews zodat iedereen juist een beetje een idee krijgt hoe het er wel aan toe gaat.
                <br/>
                <br/>
                Naja en je wist dan toen van.. lekker je eigen eiland. Dat had je dus over gehaald. Maar nu je er al een aantal keer hebt getraind, wat is het fijnste ding zeg maar aan trainen hier?
            </strong>
        </p>

        <p>
            <em>
                Ja dat is eigenlijk de effectiviteit en de flexibiliteit zeg maar. Ik hoef eigenlijk nooit na te denken van issie wel open. Zal het druk zijn de ja of de nee. Uhm want ja altijd na het werk als je wil sporten of s’weekends weet je wel, s’weekends was m’n oude gym altijd open van 9:00 tot 16:00 ja dat zijn net de tijden in het weekend dat ik niet wil sporten. He snap je. Dat is gewoon super lekker. Daarnaast dat je juist super effectief kunt trainen. Ik ben er vaak een half uur drie kwartier en dan ben ik ook weer weg. Dat helpt ook gewoon om gemotiveerd te blijven gaan. Als je weer anderhalf tot 2 uur verder bent dan is de lol er voor mij ook wel weer af. Dus dat zijn wel echt de twee grootste pluspunten.
            </em>
        </p>

        <rondleiding-button button_text="Ontdekken of Private Gym iets voor jou is? Plan direct een rondleiding"></rondleiding-button>

        <p>
            <strong>
                Ja da’s wel weer heel mooi. En zou je nog andere dingen kunnen noemen? Dingen die je vantevoren misschien niet had gedacht maar waar je wel achter bent gekomen?
            </strong>
        </p>

        <p>
            <em>
                Ja…. Nee niet perse. Het is top dat alles er is. Je moet wel weten hoe die eilanden werken. Als je echt net begint is het wel belangrijk dat je daar echt goede instructies over krijgt. Dat was voor mij wel minder toepasselijk maar.. ja als je dat eenmaal doorhebt dan eh, ja dan is het ideaal weet je. De flexibiliteit die je in de eiland hebt dat je alles zo compact hebt kunnen neerzetten ja da’s eigenlijk heel relaxt. Dat had ik niet persé verwacht.
                <br/>
                <br/>
                Want als je toch dumbbell sets en kabels dan heb je toch ruimte nodig. Maar hier eigenlijk het tegendeel. Super compact en flexibel.
            </em>
        </p>

        <p>
            <strong>
                Je hoeft niet te lopen in ieder geval ;-) Het is zo’n heerlijk geijkte vraag maar wel met een reden: zou je Private Gym aanraden aan anderen?
            </strong>
        </p>

        <p>
            <em>
                Ja absoluut. Ik denk dat de dingen waarom ik weg ben gegaan bij mn oude gym heel herkenbaar zijn voor veel mensen. Wat ik ook veel hoor bij vrienden enzo.
            </em>
        </p>

        <p>
            <strong>
                Wat zijn die dingen dan?
            </strong>
        </p>

        <p>
            <em>
                Ja dus eigenlijk ja.. dat het echt druk is waardoor je veel aan het wachten bent. Maar ook bepaalde apparaten die er niet zijn maar ook juist dat er veel cardio apparaten zijn maar dat als je voor de krachttraining komt dat soort verhoudingen niet kloppen. En dat de weekend uren dat ze niet open zijn. En kijk ja.. de andere optie is dan dat je eigenlijk 4x zoveel gaat betalen voor personal training en dit zit er juist heel mooi tussenin. Een mooie sweet spot ook. En een mooie reden om dat daarom aan te raden. Dus ja, dat zou ik zeker doen.
            </em>
        </p>

        <p>
            <strong>
                Lekker man, fijn om te horen. Zijn er nog andere dingen die je er aan toe zou willen voegen? Waar je tegenaan bent gelopen of feedback?
            </strong>
        </p>

        <p>
            <em>
                [lange stilte] Nee eigenlijk niet…
            </em>
        </p>

        <p>
            <strong>
                Ook goed he, geen antwoord is ook een antwoord! Fijn. Blij om te horen dat het zo bevalt. Hou ik je niet langer op en wil ik je bedanken. Zie ik je snel weer in de gym!
            </strong>
        </p>

        <rondleiding-button button_text="Ontdekken of Private Gym iets voor jou is? Plan direct een rondleiding"></rondleiding-button>

    </pg-page>
</template>

<script>

import PgPage from "../../Components/PgPage";
import ContactModal from "../../Components/Contact/ContactModal";
import RondleidingButton from "../../Components/Index/RondleidingButton";
export default {
    components: {RondleidingButton, ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            showFormModal: false,
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
<style>

</style>
